import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'

import { CompRatingCore } from '../core/rating/comp'
import { CompRatingWrapperCore } from '../core/rating/wrapper'

/**
 * CompRatingWrapper
 */
function CompRatingWrapper() {
  // infos
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  return <CompRatingWrapperCore infos={infosProps}>{(props) => <CompRatingCore {...props} />}</CompRatingWrapperCore>
}


export default CompRatingWrapper